import { CSSProperties, FC, ReactNode, useEffect } from 'react';
import { WbResponsiveTableToolbar } from '../WbTable/WbResponsiveTableToolbar';

interface CommonProps {
  children?: ReactNode;
  onClear?: () => void;
  clearButtonText?: string;
  style?: CSSProperties;
}

type ConditionalProps =
  | {
      onSearch: (value: string) => void | undefined;
      searchValue: string | undefined;
    }
  | {
      onSearch?: never;
      searchValue?: never;
    };

type Props = CommonProps & ConditionalProps;

/**
 * @deprecated WbTableFilters is deprecated. Use WbResponsiveTableToolbar instead.
 *
 * Migration guide:
 * ```tsx
 * // Old:
 * <WbTableFilters
 *   searchValue={search}
 *   onSearch={setSearch}
 *   onClear={() => setFilters({})}
 * >
 *   <Filter1 />
 *   <Filter2 />
 * </WbTableFilters>
 *
 * // New:
 * <WbResponsiveTableToolbar
 *   searchProps={{ value: search, onChange: setSearch }}
 *   onClear={() => setFilters({})}
 * >
 *   <WbResponsiveTableToolbar.Filters>
 *     <Filter1 />
 *     <Filter2 />
 *   </WbResponsiveTableToolbar.Filters>
 * </WbResponsiveTableToolbar>
 * ```
 */
export const WbTableFilters: FC<Props> = ({
  children,
  onClear,
  clearButtonText,
  searchValue,
  onSearch,
  style,
}) => {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn(
      'WbTableFilters is deprecated. Please use WbResponsiveTableToolbar instead. ' +
        'See component documentation for migration guide.',
    );
  }, []);

  return (
    <WbResponsiveTableToolbar
      searchProps={
        onSearch
          ? {
              value: searchValue,
              onChange: onSearch,
            }
          : undefined
      }
      onClear={onClear}
      clearButtonText={clearButtonText}
      style={style}
    >
      {children}
    </WbResponsiveTableToolbar>
  );
};
